export const iconFontAwesomeTextformattingTableCells = (
	<i className="fa-solid fa-table-cells"></i>
);
